<template>
  <Dialog v-model:visible="visible" :style="{width: '450px'}">
    <template #header>
      <h3>{{ _t('ALARM_PANEL') }} : {{ _t('label_add_new') }}</h3>
    </template>
    <div class="p-grid p-formgrid p-fluid">
      <div class="p-col-12 p-field">
        <div class="p-inputgroup">
          <span class="p-inputgroup-addon"><i class="pi pi pi-pencil"></i></span>
          <InputText :value="panel.name" :placeholder="_t('label_object_name')" @input="$emit('update:panel', { ...panel, name: $event.target.value })"/>
        </div>
      </div>
    </div>
    <div class="p-grid p-formgrid p-fluid">
      <div class="p-col-12 p-field">
        <div class="p-inputgroup">
          <span class="p-inputgroup-addon"><i class="pi pi pi-pencil"></i></span>
          <InputText :value="panel.description" :placeholder="_t('label_description')" @input="$emit('update:panel', { ...panel, description: $event.target.value })"/>
        </div>
      </div>
    </div>
    <div class="p-col-12 stripedBg">
      <OrganizationLink :modelValue="panel" :editMode="true" :required-field="true" @update:modelValue="$emit('update:panel', $event)"/>
    </div>
    <template #footer>
      <Button :label="_t('Cancel')" class="p-button-outlined p-button-secondary" @click="$emit('cancel')"/>
      <Button :label="_t('Save')" autofocus class="p-button-success" @click="$emit('save')"/>
    </template>
  </Dialog>
</template>

<script>
import OrganizationLink from '../../../components/ixarma/OrganizationLink'

export default {
  name: 'CreateAlarmPanelDialog',
  components: { OrganizationLink },
  props: {
    modelValue: { type: Boolean, required: true },
    panel: { type: Object, required: true },
  },
  emits: ['update:modelValue', 'update:panel', 'save', 'cancel'],
  computed: {
    visible: {
      get() { return this.modelValue },
      set(v) { this.$emit('update:modelValue', v) },
    },
  },
}
</script>
